import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { ToolfinderStrategyForm } from "./FormTypes";
import { useState } from "react";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonItem, IonRadio, IonRadioGroup } from "@ionic/react";
import { arrowDownOutline, createOutline } from "ionicons/icons";
import { mapStrategies } from "../../calculator/components/formHelpers";
import { useTranslation } from "react-i18next";

interface StrategyFormProps {
    isFormShowing: boolean,
    editBtnCallback: () => void,
    submitForm: (data: any) => void,
    showStrategyData: boolean
}

const defaultFormValues = {
    strategy: undefined
}

const StrategyForm: React.FC<StrategyFormProps> = ({ isFormShowing, editBtnCallback, submitForm, showStrategyData }) => {
    const [data, setData] = useState<ToolfinderStrategyForm | undefined>()
    const { control, handleSubmit, formState: { errors } } = useForm<ToolfinderStrategyForm>({
        mode: "onTouched",
        reValidateMode: "onChange",
        defaultValues: defaultFormValues
    });
    const { t } = useTranslation();

    const onSubmit: SubmitHandler<ToolfinderStrategyForm> = data => {
        setData(data)
        submitForm(data)
    }

    if (isFormShowing) {
        return (
            <>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>{t("toolfinder.Bearbeitungs-Strategie")}</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <form>
                            <Controller
                                control={control}
                                name="strategy"
                                rules={{
                                    required: { value: true, message: t("Feld darf nicht leer sein") },
                                }}
                                render={({ field: { value, onChange } }) => (
                                    <IonRadioGroup value={value} onIonChange={({ detail: { value } }) => onChange(value)}>
                                        <IonItem>
                                            <IonRadio value="std-bes" labelPlacement="end" justify="start">
                                                {t("toolfinder.strategyForm.Besäumen")}
                                            </IonRadio>
                                        </IonItem>
                                        <IonItem>
                                            <IonRadio value="std-vsp" labelPlacement="end" justify="start">
                                                {t("toolfinder.strategyForm.Vollspur")}
                                            </IonRadio>
                                        </IonItem>
                                        <IonItem>
                                            <IonRadio value="std-ko" labelPlacement="end" justify="start">
                                                {t("toolfinder.strategyForm.Kopieren")}
                                            </IonRadio>
                                        </IonItem>
                                        <IonItem>
                                            <IonRadio value="tro" labelPlacement="end" justify="start">
                                                {t("toolfinder.strategyForm.Trocut")}
                                            </IonRadio>
                                        </IonItem>
                                    </IonRadioGroup>
                                )}
                            />
                            {/* @ts-ignore */}
                            {errors.strategy && <div className="error">{errors.strategy.message}</div>}
                            <IonButton style={{ marginTop: 24 }} onClick={handleSubmit(onSubmit)} expand="block">
                                <IonIcon slot="start" icon={arrowDownOutline} />{t("toolfinder.Parameter")}
                            </IonButton>
                        </form>
                    </IonCardContent>
                </IonCard>
            </>
        )
    } else if (showStrategyData) {
        if (data) {
            return (
                <IonCard color="light" className="millerFormCompletedCard">
                    <IonCardContent>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                            <div>
                                <div><b>{t("toolfinder.Bearbeitungs-Strategie")}:</b> {data.strategy && mapStrategies(data.strategy)}</div>
                            </div>
                            <div>
                                <IonButton fill="outline" onClick={editBtnCallback}>
                                    <IonIcon icon={createOutline} slot="icon-only" />
                                </IonButton>
                            </div>
                        </div>
                    </IonCardContent>
                </IonCard>
            )
        }
        return null
    } else { return null }


}

export default StrategyForm;